import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
const MonteurLogs = () => {
  const { terms } = useAuth();
  const navigate = useNavigate();
  const [logs, setLogs] = useState([]);
  const [klanten, setKlanten] = useState([]);
  const [monteurs, setMonteurs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    klant_id: '',
    maand: new Date().toISOString().slice(0, 7),
    type: '',
    monteur_id: ''
  });

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filters.klant_id) params.append('klant_id', filters.klant_id);
      if (filters.maand) params.append('maand', filters.maand);
      if (filters.type) params.append('type', filters.type);
      if (filters.monteur_id) params.append('monteur_id', filters.monteur_id);
      const res = await api.get(`/klanten/logs/all?${params.toString()}`);
      setLogs(res.data.logs || []);
      setKlanten(res.data.klanten || []);
      setMonteurs(res.data.monteurs || []);
    } catch (err) {
      console.error('Fout bij ophalen logs:', err);
    }
    setLoading(false);
  };

  useEffect(() => { fetchLogs(); }, [filters]);

  const formatDatum = (d) => {
    return new Date(d).toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  const typeKleur = (type) => {
    const map = { storing: '#ef4444', onderhoud: '#3b82f6', vervangen: '#f59e0b', restwerk: '#8b5cf6' };
    return map[type] || '#64748b';
  };

  const selectStyle = { padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, background: 'white', color: '#1e293b', minWidth: 150 };
  const labelStyle = { display: 'block', fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 4 };

  return (
    <div style={{ padding: 24, maxWidth: 1400, margin: '0 auto', fontFamily: "'Segoe UI', sans-serif" }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontSize: 24, color: '#1e293b', margin: 0 }}>📝 Monteur Logs</h1>
        <button onClick={() => navigate('/dashboard')} style={{ padding: '8px 16px', background: '#1e293b', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14 }}>← Dashboard</button>
      </div>

      <div style={{ background: 'linear-gradient(135deg, #eff6ff, #dbeafe)', border: '1px solid #93c5fd', borderRadius: 12, padding: 20, textAlign: 'center', marginBottom: 24 }}>
        <div style={{ fontSize: 36, fontWeight: 800, color: '#1e293b' }}>{logs.length}</div>
        <div style={{ fontSize: 13, color: '#475569' }}>LOGS GEVONDEN</div>
      </div>

      <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, padding: 16, marginBottom: 24, display: 'flex', gap: 16, alignItems: 'flex-end', flexWrap: 'wrap' }}>
        <div>
          <label style={labelStyle}>{terms?.klant_singular || "Klant"}</label>
          <select style={selectStyle} value={filters.klant_id} onChange={e => setFilters({...filters, klant_id: e.target.value})}>
            <option value="">Alle {(terms?.klant_plural || "klanten").toLowerCase()}</option>
            {klanten.map(k => <option key={k.id} value={k.id}>{k.naam}</option>)}
          </select>
        </div>
        <div>
          <label style={labelStyle}>Maand</label>
          <input type="month" style={selectStyle} value={filters.maand} onChange={e => setFilters({...filters, maand: e.target.value})} />
        </div>
        <div>
          <label style={labelStyle}>Type</label>
          <select style={selectStyle} value={filters.type} onChange={e => setFilters({...filters, type: e.target.value})}>
            <option value="">Alle types</option>
            <option value="onderhoud">Onderhoud</option>
            <option value="storing">Storing</option>
            <option value="vervangen">Vervangen</option>
            <option value="restwerk">Restwerk</option>
          </select>
        </div>
        <div>
          <label style={labelStyle}>Monteur</label>
          <select style={selectStyle} value={filters.monteur_id} onChange={e => setFilters({...filters, monteur_id: e.target.value})}>
            <option value="">Alle monteurs</option>
            {monteurs.map(m => <option key={m.id} value={m.id}>{m.naam}</option>)}
          </select>
        </div>
        <button onClick={() => setFilters({ klant_id: '', maand: '', type: '', monteur_id: '' })} style={{ padding: '8px 16px', border: '1px solid #d1d5db', borderRadius: 8, background: 'white', color: '#64748b', cursor: 'pointer', fontSize: 13 }}>Reset filters</button>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#94a3b8' }}>Laden...</div>
      ) : logs.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#94a3b8' }}>Geen logs gevonden voor deze filters</div>
      ) : (
        logs.map(log => (
          <div key={log.id} style={{ background: 'white', border: '1px solid #f1f5f9', borderRadius: 12, padding: '14px 20px', marginBottom: 10, boxShadow: '0 1px 3px rgba(0,0,0,0.08)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={() => navigate(`/klant/${log.klant_id}`)}>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600, fontSize: 15, color: '#1e293b', marginBottom: 4 }}>{log.klant_naam}</div>
              <div style={{ fontSize: 13, color: '#64748b', marginBottom: 4 }}>{log.beschrijving || '-'}</div>
              <div style={{ display: 'flex', gap: 12, fontSize: 12, color: '#94a3b8' }}>
                <span>👤 {log.monteur_naam || '-'}</span>
                <span>📅 {formatDatum(log.created_at)}</span>
                {log.werkorder_id && <span>📋 W{String(log.werkorder_id).padStart(4,'0')}</span>}
              </div>
            </div>
            <span style={{ background: typeKleur(log.type), color: 'white', padding: '4px 12px', borderRadius: 12, fontSize: 12, fontWeight: 600, textTransform: 'capitalize' }}>{log.type}</span>
          </div>
        ))
      )}
    </div>
  );
};

export default MonteurLogs;
